module.exports = __webpack_public_path__ + "img/next_mob.1d487d4d.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":720,"height":460,"variants":[{"file":"img/next_mob-480w.000370b283de.webp","width":480},{"file":"img/next_mob-720w.0d460d37e8dc.webp","width":720}]};
}